import React, { useCallback, useEffect,useState } from "react";
import { serverUrl, serverImgUrl } from '../config/constants';
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
interface Props {
  fileUrl: string;
  width?: number;
  height?: number;
}

export default function PdfViewer({
  fileUrl,
  width = 200,
  height = 260,
}: Props) {
  const isPdf = fileUrl.toLowerCase().endsWith(".pdf");
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightBoxImagePath, setLightBoxImagePath] = useState('');
    

  return (
    <div
      style={{
        width:"135px",
        height:"100px",
        borderRadius: 6,
        overflow: "hidden",
        cursor: "pointer",
      }}
     
    >
      {isPdf ? (
        <div 
         className="d-flex justify-content-center align-items-center"
          style={{width: "100px",height:"100px",border:"1px solid darkgray",borderRadius: 6}}

         onClick={() => window.open(fileUrl, "_blank")}>
          <i className="bi bi-file-pdf-fill fs-5"
          style={{fontSize: "20px",color:"red"}}
          ></i>  
          </div>
      ) : (
        <div className="col" onClick={() => {
                            setLightBoxImagePath(fileUrl); setLightboxOpen(true);
                          } }>
        <img
          src={fileUrl}
          alt="Preview"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
          
        />
        </div>
      )}
      <>
        <Lightbox
        open={lightboxOpen}
        plugins={[Zoom]}    
        close={() => setLightboxOpen(false)}
        slides={[
                            {
                                src:  lightBoxImagePath,
                                alt: "edu_cert1",
                                width: 3840,
                                height: 2560,
                                srcSet: [
                                    { src: lightBoxImagePath, width: 100, height: 100 },
                                ]
                            }
                        ]}
      />
      </>
    </div>
    
  );
}
